angular
  .module('app', [
      /*
       * Order is not important. Angular makes a
       * pass to register all of the modules listed
       * and then all components are available.
       */

      /*
       * Common modules.
       * Everybody has access to these.
       */
      'app.core',
      /*
       * Feature areas
       */
      'app.topmenu',
      'app.plan',
      'app.campaign',
      'app.report',
      'app.settings',
      'app.ics',
      'datatables'
  ])
  /*
   * This runs on every application load. Since the webapp is not a single page application (yet),
   * it means it runs on every navigation away from a page, but not on tab switches handled by the
   * route provider
   */
  .run(function () { });
